<div class="wiz-box">
  <div
    class="heading">{{ (isNew ? 'wizard.step-3-edit-new.new.title' : 'wizard.step-3-edit-new.edit.title') | translate }}
    <btn class="btn-delete red" *ngIf="!isNew && isDeletable" [icon]="'far fa-times-circle'" (click)="remove()"
         routerLink="/plugplay/step-3/list"
         [label]="'wizard.step-3-edit-new.btn-remove' | translate" [classes]="['red']"></btn>
  </div>

  <div class="wiz-content">
    <div class="row">
      <div class="col" [formGroup]="userForm">
        <form-row-input [label]="'firstname'" [formGroup]="userForm" formControlName="firstName" [icon]="'far-user'"
                        [required]="userForm.get('firstName')?.errors !== null && userForm.get('firstName')?.errors?.required"
                        [requiredCssClass]="submit && userForm.get('firstName')?.errors"
                        data-cy="first-name" class="input-group-2"></form-row-input>
        <form-row-input [label]="'lastname'" [formGroup]="userForm" formControlName="lastName" [icon]="'far-list'"
                        [required]="userForm.get('lastName')?.errors !== null && userForm.get('lastName')?.errors?.required"
                        [requiredCssClass]="submit && userForm.get('lastName')?.errors"
                        data-cy="last-name" class="input-group-2"></form-row-input>
        <form-row-input [label]="'phone'" [icon]="'far-phone'" [formGroup]="userForm" formControlName="phone" data-cy="phone"
                        class="input-group-2"></form-row-input>
        <form-row-input [label]="'email'" [icon]="'far-envelope'" [formGroup]="userForm" formControlName="email"
                        [inputType]="'email'"
                        [required]="userForm.get('email')?.errors !== null && userForm.get('email')?.errors?.required"
                        [requiredCssClass]="submit && userForm.get('email')?.errors"
                        (onBlur)="checkIfEmailUnique()"
                        data-cy="email" class="input-group-2"></form-row-input>
        <div class="invalid-feedback" style="display: block; color: #f0142f; margin-bottom: 0.25rem" *ngIf="!isEmailUnique">
          {{'wizard.step-3-edit-new.email-not-unique' | translate}}
        </div>
        <form-row-password
            *ngIf="isNew"
            [isSingleInput]="true"
            [label]="'password'"
            [inputRequired]="true"
            (validityChange)="isPasswordValid = $event"
            (modelChange)="password = $event"
        ></form-row-password>
<!--        <form-row-input *ngIf="isNew" [label]="'password'" [icon]="'far-lock'" [formGroup]="userForm" formControlName="plainPassword"-->
<!--                        [required]="userForm.get('plainPassword')?.errors !== null && userForm.get('plainPassword')?.errors?.required"-->
<!--                        [inputType]="'password'" data-cy="password"-->
<!--                        [requiredCssClass]="submit && userForm.get('plainPassword')?.errors"-->
<!--                        class="input-group-2"></form-row-input>-->
      </div>
      <div class="col">
        <form-row-select-multiple
            [label]="'wizard.step-3-edit-new.select-roles'"
            [options]="userGroups"
            [optionKeyText]="'externalId'"
            [selectedValues]="selectedUserGroups"
            (selectedValuesChange)="rolesChanged($event)"
            data-cy="product-depots-filter"></form-row-select-multiple>
        <div class="step-3-dash-box">
          <h2>{{ 'wizard.step-3-edit-new.assigned-depots' | translate }}</h2>
          <form-row-checkbox *ngFor="let depot of depotsGroup" [label]="depot.name" [model]="depot.value"
                             (modelChange)="depotChanged(depot.id, $event)" [cursorPointer]="true">
          </form-row-checkbox>

          <h2>{{ 'wizard.step-3-edit-new.assigned-checkouts' | translate }}</h2>
          <form-row-checkbox *ngFor="let checkout of checkoutsGroup" [label]="checkout.name" [model]="checkout.value"
                             (modelChange)="checkoutChanged(checkout.id, $event)" [cursorPointer]="true">
          </form-row-checkbox>
        </div>
      </div>
    </div>

  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-3/list"><i
      class="fas fa-chevron-left"></i>{{ 'wizard.step-3-edit-new.btn-back' | translate }}
    </button>
    <button class="primary-btn" (click)="processSave()">{{
        (isNew ? 'wizard.step-3-edit-new.btn-create-user' :
          'wizard.step-3-edit-new.btn-save') | translate
      }}
    </button>
  </div>
</div>
